import { useEffect, useState, useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import useMedia from "use-media";
import { versionGetApi, getSoloVacancyOverview } from "../../const";
import { useStore } from "react-redux";
import common from "../../resources/RTCC/js/common/common"
import { apiKeyCheck } from "../../const";
import { Button } from "../atoms/button";
import { Label } from "../atoms/label";
import { Link } from "react-router-dom";
import SoloVacancyInfoContainer from "./soloVacancyInfoContainer";
import SoloVacancyInfoContainerCallender from "./soloVacancyInfoContainerCallender";
import "../../resources/css/soloReserve/golfSoloSearch.css"
import commonUtil from "../../common/commonUtil";
import { useRef } from "react";
import { GetPublicHoliday } from "../../hooks/getPublicHoliday";
import messageConst from "../../const/messageConst";

const GolfSoloSearchContainer = (props) => {
    const {
        playDate1,
        setPlayDate1,
        soloCourse,
        soloKaiinken,
        login,
        onClickOpenSelectDateWindow,
        onClickOpenPlanCalendarWindow,
        setGolfSoloSearchData,
        golfSoloSearchData,
        setGolfSoloTeetime,
    } = props;

    const [NotSearch, setNotSearch] = useState(false);
    const [NotStart, setNotStart] = useState(false);
    const [NotDate, setNotDate] = useState(false);
    const [NotFacility, setNotFacility] = useState(false);


    //レスポンシブ対応
    const isWideTablet = useMedia({ maxWidth: '960px' });

    const [vacancyInfo, setVacancyInfo] = useState([]);
    const [vacancyWeek, setVacancyWeek] = useState([]);
    const [MonthHead, setMonthHead] = useState("");
    const [MonthLast, setMonthLast] = useState("");

    const history = useHistory();
    const store = useStore();

    const firstDate = useRef(null);

    const { getHoliday } = GetPublicHoliday();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    // API呼出等事前処理
    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);

        // プレー日初期化処理
        let newPlayDate = new Date();
        newPlayDate.setFullYear(newPlayDate.getFullYear(), newPlayDate.getMonth(), newPlayDate.getDate() + 3)
        setPlayDate1(newPlayDate);
        firstDate.current = newPlayDate;

        //redux初期化
        setGolfSoloTeetime({});
        setGolfSoloSearchData({});


    }, []);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // カレンダー検索用検索情報取得
    const runGetVacancyList = (req) => {
        // setGolfSoloSearchData(req);
        common.doPost(getSoloVacancyOverview, req, afterGetSoloVacancyOverview);
    }

    // 空き情報取得後処理
    const afterGetSoloVacancyOverview = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            const date = new Date(data.startDate);
            setNotSearch(false);
            let twoWeeks = getWeekList(date);
            getYearMonth(twoWeeks);
            // 2週間分の空き情報
            getVacancyList(res.data.planList);
        } else {
            // エラー処理
            setNotSearch(true);
            setVacancyInfo([]);
            setMonthHead("");
        }
    }

    // 2週間分の空き情報
    const getVacancyList = (planList) => {
        let temp = [];
        if (planList !== undefined) {
            planList.forEach(plan => {
                const arry = plan.openTimeSlotDateList.map((vacancy, index) => {
                    return {
                        vacancy: vacancy.openTimeSlotNum,
                        date: vacancy.targetDate,
                    }
                });
                temp.push(
                    {
                        planName: plan.planName,
                        planId: plan.planId,
                        vacancyList: arry
                    }
                );
            });
        }
        setVacancyInfo(temp);
    }

    // 2週間分の日付情報
    const getWeekList = (nextDate) => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const array = [];
        for (let i = 0; i < 14; i++) {
            const date = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + i);

            let color = "";
            switch (date.getDay()) {
                case 0:
                    color = "red";
                    break;
                case 6:
                    color = "blue";
                    break;
                default:
                    color = "black";
                    break;
            }

            // 祝日は赤色に変更
            let holiday = getHoliday(date, date, "month");
            if (holiday === "react-calendar__tile_holiday") {
                color = "red";
            }

            const week = {
                day: date.getDate().toString(),
                month: date.getMonth(),
                week: youbi[date.getDay()],
                color: color,
                date: date,
            }
            array.push(week);
        }
        setVacancyWeek(array);
        return array;
    }

    // カレンダーの年月の表示
    const getYearMonth = (twoWeeks) => {
        const playDate = new Date(playDate1);
        const yr = playDate.getFullYear();
        const mHead = twoWeeks[0].month
        const mLast = twoWeeks[13].month

        if ((!isWideTablet && twoWeeks[0].month === twoWeeks[13].month) || (isWideTablet && twoWeeks[0].month === twoWeeks[6].month)) {
            setMonthHead(<p><span >{yr}年</span><span className='soloSearch_monthClass'>{mHead + 1}月</span></p>);
        } else {
            setMonthHead(<p><span >{yr}年</span><span className='soloSearch_monthClass'>{mHead + 1}月 ~ {mLast + 1}月</span></p>);
        }
    }

    // カレンダー空室情報移動
    const onClickMoveWeeks = (type) => {
        let newDate = commonUtil.getDateFromString(golfSoloSearchData.playDate, "-");
        if (type === "back") {
            if (isWideTablet) {
                newDate.setDate(newDate.getDate() - 7);
            } else {
                newDate.setDate(newDate.getDate() - 14);
            }
        } else {
            if (isWideTablet) {
                newDate.setDate(newDate.getDate() + 7);
            } else {
                newDate.setDate(newDate.getDate() + 14);
            }
        }
        let nextYearDate = new Date();
        nextYearDate.setFullYear(nextYearDate.getFullYear() + 1);
        nextYearDate.setHours(0);
        nextYearDate.setMinutes(0);
        nextYearDate.setSeconds(0);
        nextYearDate.setMilliseconds(0);

        firstDate.current.setHours(0);
        firstDate.current.setMinutes(0);
        firstDate.current.setSeconds(0);
        firstDate.current.setMilliseconds(0);

        if (newDate <= nextYearDate) {
            // リクエスト情報の格納
            let newGolfSoloSearchData = {
                playDate: newDate >= firstDate.current ? commonUtil.getStringFromDate(newDate, "yyyy-MM-dd") : commonUtil.getStringFromDate(firstDate.current, "yyyy-MM-dd"),
                golfCourseId: golfSoloSearchData.golfCourseId,
                golfCourseName: golfSoloSearchData.golfCourseName,
                memberShipAuth: golfSoloSearchData.memberShipAuth,
                kaiinKind:golfSoloSearchData.kaiinKind,
                contractNo: golfSoloSearchData.contractNo,
            }
            setGolfSoloSearchData(newGolfSoloSearchData);

            const reqPlanInfo = vacancyInfo.map(value => {
                return { planId: value.planId, planName: value.planName }
            })
            const req = {
                playDate: newDate >= firstDate.current ? commonUtil.getStringFromDate(newDate, "yyyy-MM-dd") : commonUtil.getStringFromDate(firstDate.current, "yyyy-MM-dd"),
                golfCourseId: golfSoloSearchData.golfCourseId,
                planInfo: reqPlanInfo,
                membershipAuthID: golfSoloSearchData.memberShipAuth,
                searchType: 0,
                kaiinKind:golfSoloSearchData.kaiinKind,
            }
            // カレンダー検索用検索情報取得
            common.doPost(getSoloVacancyOverview, req, afterGetSoloVacancyOverview);
        }

    }

    const getCalendarStartDate = () => {
        return commonUtil.getDateFromString(golfSoloSearchData.playDate, "-");
    }

    return (
        <div>
            <div className="tabWrap">
                <Button buttonText={"一人予約"} className="tabTitle" />
            </div>
            <div className="breadCrumb">
                <div className={"linkArea"}>
                    <Link to={"/reserve/top"} className={"link"} >HOME</Link>
                    <Label label=">" className={"breadCrumbArrow"} />
                    <Label label="ゴルフ一人予約" className={"link"} />
                </div>
            </div>
            <div className="soloSearch_vacancyInfoWrapper">
                <div id="callender">
                    <div className="soloSearch_searchbox">
                        {NotSearch ?
                            <div className="soloSearch_notSeach">{messageConst.PLAN_NOT_FOUND_ERROR}</div>
                            :
                            null
                        }
                        <SoloVacancyInfoContainer
                            onClickPlay={onClickOpenSelectDateWindow}
                            setVacancyInfo={setVacancyInfo}
                            setVacancyWeek={setVacancyWeek}
                            setMonthHead={setMonthHead}
                            setMonthLast={setMonthLast}
                            runGetVacancyList={runGetVacancyList}
                        />
                    </div>
                    <div className="soloSearch_searchbox2">
                        <SoloVacancyInfoContainerCallender
                            onClickPlay={onClickOpenSelectDateWindow}
                            onClickMoveWeeks={onClickMoveWeeks}
                            vacancyInfo={vacancyInfo}
                            vacancyWeek={vacancyWeek}
                            MonthHead={MonthHead}
                            MonthLast={MonthLast}
                            getCalendarStartDate={getCalendarStartDate}
                            onClickOpenPlanCalendarWindow={onClickOpenPlanCalendarWindow} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        soloCourse: state.soloCourse,
        startTime: state.startTime,
        login: state.login,
        soloKaiinken: state.soloKaiinken,
        golfSoloSearchData:state.golfSoloSearchData,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setSoloCourse: (item) => {
            dispatch({ type: "SOLO_COURSE", payload: { soloCourse: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setSoloKaiinken: (item) => {
            dispatch({ type: "SOLO_KAIINKEN", payload: { soloKaiinken: item } })
        },
        setPlayDate1: (item) => {
            dispatch({ type: "SELECT_PLAY_DATE1", payload: { playDate1: item } })
        },
        setGolfSoloSearchData: (item) => {
            dispatch({ type: "GOLF_SOLO_SEARCH_DATA", payload: { golfSoloSearchData: item } })
        },
        setGolfSoloTeetime: (item) => {
            dispatch({ type: "GOLF_SOLO_TEETIME", payload: { golfSoloTeetime: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfSoloSearchContainer);
